import script from "./PropertyMemberTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyMemberTab.vue?vue&type=script&setup=true&lang=js"

import "./PropertyMemberTab.vue?vue&type=style&index=0&id=164fe2c6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164fe2c6"]])

export default __exports__